import { CHECK_PROMOTION_REQUEST, CHECK_PROMOTION_SUCCESS, CHECK_PROMOTION_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type PromotionsCheckerInfoAction = GenericAction<
    typeof CHECK_PROMOTION_REQUEST | typeof CHECK_PROMOTION_SUCCESS | typeof CHECK_PROMOTION_ERROR,
    {
        payload: {
            code: string
            data: {
                valid: boolean
                reasons: Record<string, string | undefined>
                loading: boolean
            }
        }
    }
>

type State = Record<
    string,
    {
        valid?: boolean
        reasons?: Record<string, string | undefined>
        loading?: boolean
    }
>

const promotionsCheckerInfo = (state: State = {}, action: PromotionsCheckerInfoAction) => {
    const { type, payload } = action
    const { code } = payload ?? {}

    switch (type) {
        case CHECK_PROMOTION_REQUEST: {
            return { ...state, [code]: { loading: true } }
        }
        case CHECK_PROMOTION_ERROR:
        case CHECK_PROMOTION_SUCCESS: {
            const { data } = payload

            return { ...state, [code]: data }
        }
        default:
            return state
    }
}

export default promotionsCheckerInfo
